import React, { useEffect, useState, useRef } from 'react';
import { Menu } from 'primereact/menu';
import { Ripple } from 'primereact/ripple';
import { StyleClass } from 'primereact/styleclass';

import { Link, Navigate } from "react-router-dom";
import {useNavigate} from "react-router-dom";
import { useLocation } from 'react-router-dom';
// import Nav from 'react-bootstrap/Nav';
// import { Link, NavLink } from "react-router-dom";
// import { useContext } from "react";
// import React, { useState, useEffect } from "react";
// import Cookies from 'js-cookie';


//styles
import '../styles/index.scss';

// Import the icons
import { PrimeIcons } from 'primereact/api';

// import { 
//     Lock,
//     ChevronLeft
// } from 'react-bootstrap-icons';

function getSessionStorageOrDefault(key, defaultValue) {
    const stored =  sessionStorage.getItem(key);
    if (!stored) {
      return defaultValue;
    }
    return JSON.parse(stored);

  }


const DataNav = ({ extraNavItems }) => {

  const [datasetname, setDatasetname] = useState(null);
  const [datasetId, setDatasetId] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [openFiles, setOpenFiles] = useState([]);

  // Set the dataset name
  useEffect(() => {
    if (location.state){
      setDatasetname(location.state.name);
    }
  }, [location.state]);

  // set the dataset ID
  useEffect(() => {
      if (location.state){
        setDatasetId(location.state.id);
      }
  }, [location.state]);

  const session_sampleids = getSessionStorageOrDefault( 'sampleids', null);

//   const [session_sampleids, setSession_sampleids] = useState(getSessionStorageOrDefault( 'sampleids', null));

    // const datasetId = props.datasetId; 
    // const dataSetName = props.dataSetName;

    // const [backLabel] = useState(props.dataSetName);
    

    // const labelWithIcon = (
    //     <span>
    //       <i className={`pi ${PrimeIcons.LOCK}`} /> {backLabel}
    //     </span>
    //   );


    // const CustomMenuItem = ({ to, label, icon }) => (

    //     <NavLink to={to} activeClassName="active">
    //       <li>
    //         <i className={`pi pi-fw ${icon}`} />
    //         <span>{label}</span>
    //       </li>
    //     </NavLink>
    //   );

    

    // const items = [
    //     {
    //       label: 'Files',
    //       command: () => {
    //         navigate("files")
    //       }
    //     },
    //     {
    //     label: 'Datasets',
    //     icon: 'pi pi-fw pi-angle-left',
    //     // url: 'datasets',
    //     command: () => { 
    //       navigate("/datasets",{
    //         state:{
    //             id: datasetId,
    //             name:datasetname
    //         }
    //     });
        
    //     }
    //     // command: () => {navigate('/datasets') }
    //     },
    //     {
    //       label: 'New Samples',
    //       icon: 'pi pi-fw pi-list',
    //       // url: '/datasets/manage_sample/new_sample/upload-csv',
    //       // command: () => {navigate('manage_sample/new_sample/upload-csv') },
    //       command: () => {
    //         navigate("manage_sample/new_sample/upload-csv",{
    //           state:{
    //               id: datasetId,
    //               name:datasetname
    //           }
    //         });
    //       }
    //     },

    //     {
    //     label: 'Existing Samples',
    //     icon: 'pi pi-fw pi-cog',
    //     // url: '/datasets/manage_sample/sample',
    //     // command: () => {navigate('manage_sample/sample') },

    //     command: () => {
    //       navigate("manage_sample/sample",{
    //         state:{
    //             id: datasetId,
    //             name:datasetname
    //         }
    //       });
    //     }

    //     },
    //     {
    //     label: 'Failed Samples',
    //     icon: 'pi pi-fw pi-ban',
    //     // command: () => {navigate('manage_sample/failed_sample') },
    //     command: () => {
    //       navigate("manage_sample/failed_sample",{
    //         state:{
    //             id: datasetId,
    //             name:datasetname
    //         }
    //       });
    //     }
    //     },
    //     {
    //     label: 'Merge Samples',
    //     icon: 'pi pi-fw pi-arrow-right-arrow-left',
    //     // command: () => {navigate('manage_sample/merge_sample') },
    //     command: () => {
    //       navigate("manage_sample/merge_sample",{
    //         state:{
    //             id: datasetId,
    //             name:datasetname
    //         }
    //       });
    //     }
    //     },
    // ];

    // const fileDisplays = extraNavItems.files.map(file => {

    // })
    
    return (
      <div className="surface-section h-screen border-right-1 surface-border flex flex-column w-14rem select-none">
      <div className="overflow-y-auto">
          <ul className="list-none p-2 m-0">
              <li>
                  <div className="p-3 text-500 font-medium">FILES</div>
              </li>
              <li>
                  <Link to='files' className="p-ripple flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 border-round transition-colors transition-duration-150 w-full">
                      {/* <i className="pi pi-home mr-2"></i> */}
                      <span className={`font-medium ${location.pathname==='/datasets/files' && 'border border-primary rounded p-1'}`}>Dashboard</span>
                      <Ripple />
                  </Link>
                  <Link to='files/upload' className="p-ripple flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 border-round transition-colors transition-duration-150 w-full">
                      {/* <i className="pi pi-home mr-2"></i> */}
                      <span className={`font-medium ${location.pathname==='/datasets/files/upload' && 'border border-primary rounded p-1'}`}>Upload</span>
                      <Ripple />
                  </Link>
                  {location.pathname.includes('/datasets/files/filedetails/') && <Link to='#' className="p-ripple flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 border-round transition-colors transition-duration-150 w-full">
                      {/* <i className="pi pi-home mr-2"></i> */}
                      <span className={`font-medium ${location.pathname.includes('/datasets/files/filedetails/') && 'border border-primary rounded p-1'}`}>File Details</span>
                      <Ripple />
                  </Link>}
              </li>
              {/* <li>
                  <StyleClass nodeRef={btnRef3} selector="@next" enterClassName="hidden" enterActiveClassName="slidedown" leaveToClassName="hidden" leaveActiveClassName="slideup">
                      <a ref={btnRef3} className="p-ripple flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 border-round transition-colors transition-duration-150 w-full">
                          <i className="pi pi-calendar mr-2"></i>
                          <span className="font-medium">Calendar</span>
                          <div className="ml-auto">
                              <i className="pi pi-chevron-down ml-2"></i>
                          </div>
                          <Ripple />
                      </a>
                  </StyleClass>
                  <ul className="list-none py-0 pl-3 pr-0 m-0 hidden overflow-y-hidden transition-all transition-duration-400 transition-ease-in-out">
                      <li>
                          <a className="p-ripple flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 border-round transition-colors transition-duration-150 w-full">
                              <i className="pi pi-calendar mr-2"></i>
                              <span className="font-medium">Work</span>
                              <Ripple />
                          </a>
                      </li>
                      <li>
                          <a className="p-ripple flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 border-round transition-colors transition-duration-150 w-full">
                              <i className="pi pi-calendar mr-2"></i>
                              <span className="font-medium">Personal</span>
                              <Ripple />
                          </a>
                      </li>
                  </ul>
              </li> */}
          </ul>
          <ul className="list-none p-2 m-0 border-top-1 surface-border">
              <li>
                  <div className="p-3 text-500 font-medium">SAMPLES</div>
              </li>
              <li>
                  <Link to='manage_sample/sample' className="p-ripple flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 border-round transition-colors transition-duration-150 w-full">
                      {/* <i className="pi pi-home mr-2"></i> */}
                      <span className={`font-medium ${location.pathname==='/datasets/manage_sample/sample' && 'border border-primary rounded p-1'}`}>Dashboard</span>
                      <Ripple />
                  </Link>
              </li>
              <li>
                  <Link to='create_sample' className="p-ripple flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 border-round transition-colors transition-duration-150 w-full">
                      {/* <i className="pi pi-home mr-2"></i> */}
                      {/* <span className={`font-medium ${location.pathname==='/datasets/manage_sample/new_sample/upload-csv' && 'border border-primary rounded p-1'}`}>Create Sample</span> */}
                      <span className={`font-medium ${location.pathname==='/datasets/create_sample' && 'border border-primary rounded p-1'}`}>Create Samples</span>
                      <Ripple />
                  </Link>
              </li>



                <li>
                    {  ( session_sampleids || location.pathname.includes('/datasets/list_samples') ) && 
                        <Link to='/datasets/list_samples' className="p-ripple flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 border-round transition-colors transition-duration-150 w-full">
                            {/* <i className="pi pi-home mr-2"></i> */}
                            <span className={`font-medium ${location.pathname.includes('/datasets/list_samples') && 'border border-primary rounded p-1'}`}>Sample List</span>
                            {/* <span className={`font-medium ${location.pathname==='/datasets/list_samples' && 'border border-primary rounded p-1'}`}>Create Samples</span> */}
                            <Ripple />
                        </Link>}
                </li>

                <li>
                    {location.pathname.includes('/datasets/sample_details') && <div reloadDocument className="p-ripple flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 border-round transition-colors transition-duration-150 w-full">
                            {/* <i className="pi pi-home mr-2"></i> */}
                            <span className={`font-medium ${location.pathname.includes('/datasets/sample_details') && 'border border-primary rounded p-1'}`}><u>Sample Details</u></span>
                            <Ripple />
                        </div>}
                </li>

              {/* <li>
                  <Link to='manage_sample/failed_sample' className="p-ripple flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 border-round transition-colors transition-duration-150 w-full">
                      <i className="pi pi-exclamation-circle mr-2"></i>
                      <span className={`font-medium ${location.pathname==='/datasets/manage_sample/failed_sample' && 'border border-primary rounded p-1'}`}>Failed Samples</span>
                      <Ripple />
                  </Link>
              </li> */}

              {/* <li>
                  <StyleClass nodeRef={btnRef4} selector="@next" enterClassName="hidden" enterActiveClassName="slidedown" leaveToClassName="hidden" leaveActiveClassName="slideup">
                      <a ref={btnRef4} className="p-ripple flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 border-round transition-colors transition-duration-150 w-full">
                          <i className="pi pi-file mr-2"></i>
                          <span className="font-medium">Reports</span>
                          <div className="ml-auto">
                              <i className="pi pi-chevron-down ml-2"></i>
                          </div>
                          <Ripple />
                      </a>
                  </StyleClass>
                  <ul className="list-none py-0 pl-3 pr-0 m-0 hidden overflow-y-hidden transition-all transition-duration-400 transition-ease-in-out">
                      <li>
                          <StyleClass nodeRef={btnRef5} selector="@next" enterClassName="hidden" enterActiveClassName="slidedown" leaveToClassName="hidden" leaveActiveClassName="slideup">
                              <a ref={btnRef5} className="p-ripple flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 border-round transition-colors transition-duration-150 w-full">
                                  <i className="pi pi-chart-line mr-2"></i>
                                  <span className="font-medium">Analytics</span>
                                  <i className="pi pi-chevron-down ml-auto"></i>
                                  <Ripple />
                              </a>
                          </StyleClass>
                          <ul className="list-none py-0 pl-3 pr-0 m-0 hidden overflow-y-hidden transition-all transition-duration-400 transition-ease-in-out">
                              <li>
                                  <a className="p-ripple flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 border-round transition-colors transition-duration-150 w-full">
                                      <i className="pi pi-refresh mr-2"></i>
                                      <span className="font-medium">Traffic</span>
                                      <Ripple />
                                  </a>
                              </li>
                              <li>
                                  <a className="p-ripple flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 border-round transition-colors transition-duration-150 w-full">
                                      <i className="pi pi-dollar mr-2"></i>
                                      <span className="font-medium">Conversions</span>
                                      <Ripple />
                                  </a>
                              </li>
                          </ul>
                      </li>
                      <li>
                          <a className="p-ripple flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 border-round transition-colors transition-duration-150 w-full">
                              <i className="pi pi-chart-bar mr-2"></i>
                              <span className="font-medium">Sales</span>
                              <Ripple />
                          </a>
                      </li>
                  </ul>
              </li> */}
          </ul>
          <ul className="list-none p-2 m-0 border-top-1 surface-border">
              <li>
                  <div className="p-3 text-500 font-medium">DATASETS</div>
              </li>
              <li>
                  <Link to='' className="p-ripple flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 border-round transition-colors transition-duration-150 w-full">
                      {/* <i className="pi pi-home mr-2"></i> */}
                      <span className={`font-medium ${location.pathname==='/datasets' && 'border border-primary rounded p-1'}`}>Dashboard</span>
                      <Ripple />
                  </Link>
              </li>
              <li>
                  <Link to='manage_sample/merge_sample' className="p-ripple flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 border-round transition-colors transition-duration-150 w-full">
                      {/* <i className="pi pi-home mr-2"></i> */}
                      <span className={`font-medium ${location.pathname==='/datasets/manage_sample/merge_sample' && 'border border-primary rounded p-1'}`}>Merge Samples</span>
                      <Ripple />
                  </Link>
              </li>

              <li>
                    {location.pathname.includes('/datasets/dataset_details') && <Link to='#' className="p-ripple flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 border-round transition-colors transition-duration-150 w-full">
                            {/* <i className="pi pi-home mr-2"></i> */}
                            <span className={`font-medium ${location.pathname.includes('/datasets/dataset_details') && 'border border-primary rounded p-1'}`}>Dataset Details</span>
                            <Ripple />
                        </Link>}
                </li>
          </ul>
      </div>
  </div>
    );
    };
      

      



    // return ( 
    //     <div className="datasets-nav">
    //         <Nav defaultActiveKey="link-1" className="flex-sm-column">

    //             <Nav.Link 
    //                 eventKey="link-0" 
    //                 as={NavLink} 
    //                 to="/datasets"
    //                 className='border-0'><ChevronLeft /><Lock />&nbsp;{dataSetName}</Nav.Link>

    //             {/* <Nav.Link href="/home">Active</Nav.Link> */}
    //             <Nav.Link 
    //                 eventKey="link-1" 
    //                 as={NavLink} 
    //                 to="manage_sample/new_sample/upload-csv" 
    //                 state={{ id: dataSetName }}>New Samples</Nav.Link>
    //             <Nav.Link 
    //                 eventKey="link-2"
    //                 as={NavLink} 
    //                 to="manage_sample/sample" 
    //                 state={{ id: dataSetName }}>Existing Samples</Nav.Link>
    //             <Nav.Link 
    //                 eventKey="link-3"
    //                 state={{ id: dataSetName }}>Failed Samples</Nav.Link>
    //             <Nav.Link 
    //                 eventKey="link-4"
    //                 state={{ id: dataSetName }}>Merge Samples</Nav.Link>
    //             {/* <Nav.Link 
    //                 eventKey="disabled" disabled
    //                 state={{ id: dataSetName }}>
    //             Disabled
    //             </Nav.Link> */}
    //         </Nav>
    //   </div>
    // );
//   }
  
export default DataNav;